/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';

import GraphCMSComponents from '../global/GraphCMSComponents';
import Analytics from '../global/Analytics';

export default class ProductBelowFold extends Component {
  toggleAccordion() {
    const openToggle = !this.state.openToggle;
    this.setState({
      openToggle,
    });
    try {
      const {
        header: source = '',
        userDetails: {
          email = '',
        },
      } = this.props;
      Analytics.enqueue({
        method: 'track',
        params: {
          event: 'PDP Below The Fold Accordion',
          properties: {
            action: openToggle ? 'Opened' : 'Closed',
            source,
            email,
          },
        },
        location: Analytics.getLocation(),
      });
    } catch (e) { /* nothing to do */ }
  }

  render() {
    const {
      components,
      productDetails,
      fetchReviewsAverageRating,
      userDetails,
      location,
      history,
    } = this.props;

    return (
      <GraphCMSComponents
        components={components}
        productDetails={productDetails}
        userDetails={userDetails}
        isPDP={true}
        toggleAccordion={this.toggleAccordion}
        location={location}
        history={history}
        fetchReviewsAverageRating={fetchReviewsAverageRating}
      />
    );
  }
}
